import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadFile, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { finalize, Observable, Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { HttpFileService } from '../../../service/http-file.service';
import { FormBuilder } from '@angular/forms';
import { NzModalService } from 'ng-zorro-antd/modal';
import { HttpEventType } from '@angular/common/http';
import { FileUploadDto } from '../../../service/dto';

@Component({
	selector: 'app-member-bulk-upload',
	standalone: false,
	templateUrl: './member-bulk-upload.component.html',
	styleUrl: './member-bulk-upload.component.scss'
})
export class MemberBulkUploadComponent {
	uploadedFile?: FileUploadDto;
	uploadProgress?: number;

	constructor(
		private fileService: HttpFileService,
		private fb: FormBuilder,
		private modal: NzModalService) {
	}

	customUpload = (item: NzUploadXHRArgs): any => {
		this.uploadProgress = 0;

		const subscription = this.fileService.uploadWithProgress(item.name ?? 'bulk-member-upload', item.file as any)
			.pipe(finalize(() => this.uploadProgress = undefined))
			.subscribe({
				next: (event) => {
					if (event.type === HttpEventType.Response) {
						this.uploadProgress = 100;
						this.uploadedFile = event.body as FileUploadDto;
					}
					if (event.type === HttpEventType.UploadProgress) {
						console.log(`Event Total: [${event.total} - Event Loaded [${event.loaded}]]`);
						const percentage = Math.round((100 * event.loaded) / (event.total ?? event.loaded));
						this.uploadProgress = percentage == 100 ? 99 : percentage;
					}
				},
				error: (err) => item.onError!(err, item.file!)
			});
		return { abort() { subscription.unsubscribe(); } };
	}
}
